// @ts-nocheck
import {
    pageTitleStyles,
    ProductDetailsPageTitleStyles,
} from "@insite/content-library/Widgets/ProductDetails/ProductDetailsPageTitle";

Object.assign<ProductDetailsPageTitleStyles>(pageTitleStyles, {
    titleText: {
        variant: "h2",
        forwardAs: "h1",
    },
});
